import { AxiosError } from 'axios';
import * as Sentry from "@sentry/react";
import { getClientId } from '../../utils';
import ParentsRequest from '../../utils/parentsRequest';
import { KEY_PARENTS_API_TYPE_PARENT, SESSION_KEY_LOCATION_ID } from '../../constants';
import { Child } from '../../types';

const createUser = async (firstname: string, lastname: string, email: string, phone: string, password: string, childrenData: Child[]) => {
    let createUserResponse = {
        success: false,
        message: 'Failed to create user.',
        data: null,
        jwt: null,
        payer_id: null,
    };

    try {
        const clientId = getClientId();
        const children = childrenData.map((child) => {
            return {
                firstname: child.fname,
                lastname: child.lname,
                dob: new Date(child.dob).toLocaleDateString('en-GB'),
                gender: child.gender,
                location: localStorage.getItem(SESSION_KEY_LOCATION_ID)
            };
        });

        const response = await ParentsRequest.post('/users/register', {
            firstname,
            lastname,
            email,
            phone,
            password,
            domain: clientId,
            type: KEY_PARENTS_API_TYPE_PARENT,
            children
        });

        if (response.data.success == true) {
            createUserResponse.success = true;
            createUserResponse.message = 'User created successfully.';
            createUserResponse.data = response.data.data.userId;
            createUserResponse.jwt = response.data.data.token;
            createUserResponse.payer_id = response.data.data.payerId;
        } else {
            createUserResponse.message = response.data.message;
        }

        return createUserResponse;
    } catch (error) {
        Sentry.captureException(error);
        const axiosError = error as AxiosError<{ errors?: { password?: string } }>;
        if (axiosError.response && axiosError.response.status === 409) {
            createUserResponse.message = 'Email already registered.';
        }
        const errors = (axiosError.response?.data as any).errors;
        if (errors.password) {
            createUserResponse.message = 'A minimum 8 characters password contains a combination of <strong>uppercase, lowercase letter</strong>,<strong>numbers</strong> and special characters like <strong>@$!%*#?&</strong>'
        }
        return createUserResponse;
    }
};

export default createUser;
